// extracted by mini-css-extract-plugin
export default {"root":"NoOrderResults_root__AMJ7J","content":"NoOrderResults_content__WioG3","message":"NoOrderResults_message__UfnOs"};